import {DocumentEditorContainerFields} from '../../components-fields/document-editor-container-fields';

export const DocumentEditorContainerFrenchTranslation: DocumentEditorContainerFields = {
  Header: `Entête`,
  Link: `Lien`,
  Single: 'Seule',
  Double: 'Double',
};
